import H from 'constants/httpMethod.const';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beMarketingEmail'); // eslint-disable-line no-unused-vars
// salon and user
const fromDtoToEmail = (dto) => ({
  salonHasABrand: dto?.results?.salon_has_a_brand,
  currentUserInvited: dto?.results?.current_user_invited,
  currentUserVerified: dto?.results?.current_user_verified,
  freeBlasts: dto?.results?.free_blasts,
});

const fromEmailToDto = (item) => ({
  salon_has_a_brand: item?.salonHasABrand,
  current_user_invited: item?.currentUserInvited,
  current_user_verified: item?.currentUserVerified,
  free_blasts: item?.freeBlasts,
});

// invite
const fromDtoToResendInvite = (dto) => ({
  currentUserReinvited: dto?.results?.current_user_reinvited,
});

const fromResendInviteToDto = (item) => ({
  current_user_reinvited: item?.currentUserReinvited,
});

// estimate
const fromDtoToEmailEstimate = (dto) => ({
  expectedCount: dto?.results?.expected_count ?? 0,
  expectedCost: dto?.results?.expected_cost ?? 0,
  cosPerEmail: dto?.results?.cost_per_email ?? 0,
});

const fromEmailEstimateToDto = (item) => ({
  recipients: asArray(item?.recipients),
});

// draft
const fromDtoToEmailDraft = (dto) => ({
  importId: dto?.results?.import_id ?? null, // will take importId and start polling
});

const fromEmailDraftToDto = (item) => ({
  recipients: asArray(item?.recipients),
});

// poll
const fromDtoToEmailPoll = (dto) => ({
  campaignUrl: fromAnyToTrimmed(dto?.results?.campaign_url),
  details: fromAnyToTrimmed(dto?.results?.details),
});

const fromEmailPollToDto = (item) => ({
  import_job_id: item?.importJobId,
});

// analytics
const fromDtoToEmailAnalytics = (dto) => {
  const campaignsDto = dto?.results?.campaigns ?? {};

  const campaigns = Object.entries(campaignsDto).map(([id, c]) => ({
    id,
    campaignSent: c?.campaign_sent ?? '',
    campaignUrl: c?.campaign_url ?? '',
    name: c?.name ?? '',
    sends: c?.sends ?? 0,
    // delivered // TODO: scoped out, change css grid if it's added
    opens: c?.opens ?? 0,
    clicks: c?.clicks ?? 0,
    count: c?.count ?? 0, // bookings
    revenue: c?.revenue ?? 0,
    cost: c?.cost ?? 0,
  }));

  return {
    campaigns,
    totalAppointmentsCount: dto?.results?.total_appointments_count ?? 0,
    totalClientsCount: dto?.results?.total_clients_count ?? 0,
    totalRevenue: dto?.results?.total_revenue ?? 0,
  };
};

export const beMarketingEmailRead = actionEndpointBe(
  'beMarketingEmailRead',
  H.get,
  'salon/v3/:salonId/marketing/email/enable/',
  (options) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToEmail,
  }),
);

export const beMarketingEmailWrite = actionEndpointBe(
  'beMarketingEmailWrite',
  H.post,
  'salon/v3/:salonId/marketing/email/enable/',
  (options) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToEmail,
    toDto: fromEmailToDto,
  }),
);

export const beMarketingEmailResendInvite = actionEndpointBe(
  'beMarketingEmailResendInvite',
  H.post,
  'salon/v3/:salonId/marketing/email/resend_invite/',
  (options) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToResendInvite,
    toDto: fromResendInviteToDto,
  }),
);

// estimate
export const beMarketingEmailEstimateWrite = actionEndpointBe(
  'beMarketingEmailEstimateWrite',
  H.post,
  'salon/v3/:salonId/marketing/email/estimate/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToEmailEstimate,
    toDto: fromEmailEstimateToDto,
    data: extra?.data,
  }),
);

// draft
export const beMarketingEmailDraftWrite = actionEndpointBe(
  'beMarketingEmailDraftWrite',
  H.post,
  'salon/v3/:salonId/marketing/email/draft/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToEmailDraft,
    toDto: fromEmailDraftToDto,
    data: extra?.data,
  }),
);

// poll
export const beMarketingEmailPollWrite = actionEndpointBe(
  'beMarketingEmailPollWrite',
  H.post,
  'salon/v3/:salonId/marketing/email/poll/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToEmailPoll,
    toDto: fromEmailPollToDto,
    data: extra?.data,
  }),
);

// email analytics
export const beMarketingEmailAnalyticsRead = actionEndpointBe(
  'beMarketingEmailAnalyticsRead',
  H.get,
  'salon/v3/:salonId/marketing/email/analytics/',
  (options) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToEmailAnalytics,
  }),
);
